import { render, staticRenderFns } from "./SepBill.vue?vue&type=template&id=154a8bc1&scoped=true&"
import script from "./SepBill.vue?vue&type=script&lang=js&"
export * from "./SepBill.vue?vue&type=script&lang=js&"
import style0 from "./SepBill.vue?vue&type=style&index=0&id=154a8bc1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154a8bc1",
  null
  
)

export default component.exports